import { render, staticRenderFns } from "./contract-record-detail.vue?vue&type=template&id=1182cc94&scoped=true&"
import script from "./contract-record-detail.vue?vue&type=script&lang=js&"
export * from "./contract-record-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1182cc94",
  null
  
)

export default component.exports